import { render, staticRenderFns } from "./quality-repository.vue?vue&type=template&id=0a7dd080"
import script from "./quality-repository.vue?vue&type=script&lang=js"
export * from "./quality-repository.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports